import Checkbox from 'CMFW/input/Checkbox';
import TextInput from 'CMFW/input/TextInput';
import React, { useContext, useState } from 'react';
import styled from 'styled-components';
import SplitSelect from '../common/SplitSelect';
import { changeAwareMixin, EditorRow, IChangeAwareProps } from '../common/styles';
import InflectViewModal from './InflectViewModal';
import AsyncTaskWrapper from '../../CMFW/input/AsyncTaskWrapper';
import ModuleContext from '../../CMFW/context/ModuleContext';
import { IInflectConfig } from '../../types/inflect';
import KeyContext from '../../CMFW/context/KeyContext';
import Button from '@material-ui/core/Button';

const InflectConfig: React.FC = () => {
  const [showModal, setShowModal] = useState(false);
  const parentKey = useContext(KeyContext);
  const module = useContext(ModuleContext);
  const moduleItemValue: IInflectConfig = module.getItemUpdatedValue(parentKey);

  const handleShowInflects = () => {
    setShowModal(true);
  };

  const handleCloseShowInflects = () => {
    setShowModal(false);
  };

  return (
    <>
      <EditorRow>
        <TextInput keyName={'inflectWord'} label={'Inflect Word'} inputProps={{ maxLength: 255 }} />
        {moduleItemValue.transcriptionHidden === false && (
          <TranscriptionInput keyName={'transcription'} label={'Transcription'} inputProps={{ maxLength: 255 }} />
        )}
        <SplitSelect keyName={'splitType'} />
        <CheckboxStyled keyName={'preselected'} label="Pre-Selected" />
        <AsyncTaskWrapper task={moduleItemValue.nInflects} keyValue={'nInflects'}>
          <ButtonStyled onClick={handleShowInflects} $changed={false} variant="outlined">
            {moduleItemValue.nInflects.value}
          </ButtonStyled>
        </AsyncTaskWrapper>
      </EditorRow>
      {showModal && <InflectViewModal onClose={handleCloseShowInflects} />}
    </>
  );
};

export default InflectConfig;

const TranscriptionInput = styled(TextInput)`
  && {
    margin-left: 12px;
  }
`;

const ButtonStyled = styled(Button)<IChangeAwareProps>`
  && {
    ${changeAwareMixin}
  }
`;

const CheckboxStyled = styled(Checkbox)`
  && {
    white-space: nowrap;
  }
`;
